import { FileFetchingDetails, IntegrationData, PlatformIntegrationData } from "../Integrations.types"
import {
	integrationListCVList,
	integrationGetCVContent,
	integrationGetUserDetails,
	storeOAuthPkceVerifier,
} from "shared/src/libs/apiLib/apiLib"
import { generateCodeChallenge, generateCodeVerifier } from "shared/src/libs/oauthLib/pkce"
import {
	expandJsonSize,
	reduceJsonSize,
	REVERSE_STATE_JSON_MAPPING,
	STATE_JSON_MAPPING,
} from "shared/src/libs/oauthLib/compressJson"

export const salesforceClientId =
	"3MVG9SiMalB_c8x5Zf489nOm1Ainsnw7eQkrMDiaBvk88IHn.tB.I4obvDJYI3pmRNmrivsF3511kZjDgrkX3" // external client app

const baseUrl =
	process.env.VITE_IS_DEV === "true" || process.env.VITE_IS_TEST === "true"
		? "https://test.salesforce.com"
		: "https://login.salesforce.com"

export const salesforceIntegrationData: PlatformIntegrationData<
	"oauthLogin" | "setupUser" | "candidateProfile" | "chooseFile" | "fetchFile" | "confirmationPage"
> = {
	allowChat: true,
	parameterMapping: {
		clientId: "clientId",
		externalClientId: "externalClientId",
		externalId: "externalId",
		userId: "userId",
		shortId: "shortId",
	},
	pages: ["oauthLogin", "setupUser", "candidateProfile", "chooseFile", "fetchFile", "confirmationPage"],
	props: {
		oauthLogin: {
			newTab: true,
			createStateData: ({ integrationData, clientId }) => ({
				integrationData,
				shortId: integrationData.shortId,
				clientId,
			}),
			getLoginUrl: async (integrationData: IntegrationData, state?: string) => {
				const stateObj: { clientId: string } = state ? expandJsonSize(state, REVERSE_STATE_JSON_MAPPING) : {}

				const codeVerifier = generateCodeVerifier()
				const codeChallenge = await generateCodeChallenge(codeVerifier)
				// stored server-side (not localStorage) since this page can be loaded in an iframe,
				// where client-side storage may be partitioned/blocked
				const { verifierId } = await storeOAuthPkceVerifier(stateObj.clientId, codeVerifier)

				const newState = reduceJsonSize({ ...stateObj, codeVerifierId: verifierId }, STATE_JSON_MAPPING)
				const stateQueryString = `&state=${encodeURIComponent(newState)}`

				return `${baseUrl}/services/oauth2/authorize?client_id=${encodeURIComponent(salesforceClientId)}&response_type=code&redirect_uri=${window.location.origin}/oauthcallback${stateQueryString}&code_challenge=${encodeURIComponent(codeChallenge)}&code_challenge_method=S256`
			},
		},
		setupUser: {
			getUserDetails: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationGetUserDetails(integrationData, clientId)
			},
		},
		fetchFile: {
			getFile: async (clientId: string, integrationData: IntegrationData, fileFetchingDetails: FileFetchingDetails) => {
				return await integrationGetCVContent(integrationData, fileFetchingDetails, clientId)
			},
		},
		chooseFile: {
			listFiles: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationListCVList(integrationData, clientId)
			},
		},
		confirmationPage: {},
		candidateProfile: {},
	},
	initialData: {},
	useFrontendFileUpload: true,
}
